import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    const options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        totalAmount: [
          !_.isNil(entity?.parameters?.supportsInvestment?.totalAmount)
            ? entity?.parameters?.supportsInvestment?.totalAmount
            : null,
          [Validators.required, Validators.min(0)],
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }

  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  get productId() {
    return this.products.get(`${0}`).get('productId').value;
  }

  get versementAmountControl() {
    return this.products.get(`${0}`).get('parameters').get('totalAmount');
  }

  extract() {
    const products = _.cloneDeep(this.form?.value?.products);
    products?.forEach((product, index) => {
      const totalAmount = !_.isNil(product?.parameters?.totalAmount)
        ? +product.parameters.totalAmount
        : null;

      product.parameters.totalAmount = undefined;
      product.parameters.supportsInvestment = {
        totalAmount,
        supportRepartition:
          this.entity?.products?.[index]?.parameters?.supportsInvestment
            ?.supportRepartition || [],
      };
    });
    return products;
  }
}
